import { render, staticRenderFns } from "./OccupancyRentalDeductionsHelp.vue?vue&type=template&id=99f8bae2&scoped=true"
import script from "./OccupancyRentalDeductionsHelp.vue?vue&type=script&lang=js"
export * from "./OccupancyRentalDeductionsHelp.vue?vue&type=script&lang=js"
import style0 from "./OccupancyRentalDeductionsHelp.vue?vue&type=style&index=0&id=99f8bae2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99f8bae2",
  null
  
)

export default component.exports